import React from 'react';
import { Grid } from 'semantic-ui-react';
import isURL from 'validator/es/lib/isURL';
import { hasMinimumLength } from '@/utils/resultsHelper';
import { translatedError } from '@/utils/errors';
import fields, { fieldLengths, globalFieldLengths } from '@/constants/fields';
import DatasourceInputField from './DatasourceInputField';
import DatasourceUrlHostField from './DatasourceUrlHostField';

export const validateDatasourceTokenFieldsForTest = (settings) => {
  const errors = [];
  if (!hasMinimumLength(settings.host)) {
    errors.push(translatedError(
      'dataset.datasource',
      null,
      'validation.host.required',
      [fields.HOST],
    ));
  }

  if (!isURL(settings.host || '')) {
    errors.push(translatedError(
      'dataset.datasource',
      null,
      'validation.uri.not.valid',
      [fields.HOST],
    ));
  }

  if (!hasMinimumLength(settings.name)) {
    errors.push(translatedError(
      'dataset.datasource',
      null,
      'validation.dataset.required',
      [fields.NAME],
    ));
  }

  if (!hasMinimumLength(settings.password)) {
    errors.push(translatedError(
      'dataset.datasource',
      null,
      'validation.token.required',
      [fields.PASSWORD],
    ));
  }

  return errors;
};

export const validateDatasourceTokenFields = (settings, errors) => {
  errors.push(...validateDatasourceTokenFieldsForTest(settings));

  if (settings.host && settings.host.length > globalFieldLengths.url) {
    errors.push(translatedError(
      'dataset.datasource',
      'save.dataset.datasource.validation.host.title',
      'validation.max.length',
      [fields.HOST],
      { maximum: globalFieldLengths.url },
    ));
  }

  if (settings.name && settings.name.length > fieldLengths.medium) {
    errors.push(translatedError(
      'dataset.datasource',
      'save.dataset.datasource.validation.name.title',
      'validation.max.length',
      [fields.NAME],
      { maximum: fieldLengths.medium },
    ));
  }

  if (settings.password && settings.password.length > fieldLengths.large) {
    errors.push(translatedError(
      'dataset.datasource',
      'save.dataset.datasource.validation.password.title',
      'validation.max.length',
      [fields.PASSWORD],
      { maximum: fieldLengths.large },
    ));
  }
};

const DatasourceTokenFields = ({ disabled, settings, updateSettings }) => (
  <>
    <Grid.Row>
      <DatasourceUrlHostField
        disabled={disabled}
        host={settings.host}
        saveErrors={settings.saveErrors}
        updateSettings={updateSettings}
      />
      <DatasourceInputField
        disabled={disabled}
        entity="dataset"
        field={fields.NAME}
        onChange={(value) => updateSettings({ name: value })}
        saveErrors={settings.saveErrors}
        text={settings.name}
      />
    </Grid.Row>
    <Grid.Row>
      <DatasourceInputField
        disabled={disabled}
        entity="token"
        field={fields.PASSWORD}
        maxLength={fieldLengths.large}
        onChange={(value) => updateSettings({ password: value })}
        saveErrors={settings.saveErrors}
        text={settings.password}
        type="password"
      />
    </Grid.Row>
  </>
);

export default DatasourceTokenFields;
